import { Box, IconButton, Popper } from "@mui/material";
import InfoCircle from "Icons/InfoCircle";
import Close from "Icons/Close";
import { useState } from "react";
export default function InfoIcon({ text, width = "30px", height = "30px", fillColour, className, style }) {
  const [popperState, setPopperState] = useState({ open: false, anchorElement: null });
  return (
    <>
      <div
        height={height}
        onMouseEnter={(e) => setPopperState({ open: true, anchorElement: e.currentTarget })}
        onMouseLeave={(e) => {
          setPopperState({ open: false, anchorElement: null });
        }}
        onTouchStart={(e) => setPopperState({ open: true, anchorElement: e.currentTarget })}
      >
        <InfoCircle width={width} height={height} fillColour={fillColour} className={className} style={style} />
      </div>
      <Popper open={popperState.open} anchorEl={popperState.anchorElement} placement="left">
        <Box
          sx={{
            backgroundColor: "rgb(251,250,250)",
            maxWidth: "350px",
            boxShadow: `0px 0px 15px ${fillColour}`,
            borderRadius: "15px",
            mr: 3,
          }}
        >
          <Box sx={{ textAlign: "end" }}>
            <IconButton onClick={(e) => setPopperState({ open: false, anchorElement: null })}>
              <Close width="25px" height="25px" fillColour={fillColour} />
            </IconButton>
          </Box>
          <Box
            sx={{
              padding: " 0px 15px 10px 15px",
              wordWrap: "break-word",
              mr: 3,
            }}
          >
            {text}
          </Box>
        </Box>
      </Popper>
    </>
  );
}
